import { useEffect, useState } from 'react';

const cls = (...classes) => classes.filter(Boolean).join(' ');

export default function PillTabs({ tabs, value, onChange, ariaLabel = 'Audience selector' }) {
  const [active, setActive] = useState(value || tabs[0]?.id);

  useEffect(() => {
    if (value) {
      setActive(value);
    }
  }, [value]);

  const select = (id) => {
    setActive(id);
    onChange?.(id);
    if (typeof window !== 'undefined' && window.history) {
      window.history.replaceState(null, '', `#${id}`);
    }
  };

  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      className="flex flex-col gap-4 sm:flex-row sm:flex-wrap"
    >
      {tabs.map((tab) => {
        const selected = tab.id === active;
        return (
          <button
            key={tab.id}
            id={`tab-${tab.id}`}
            type="button"
            role="tab"
            aria-selected={selected}
            aria-controls={`panel-${tab.id}`}
            onClick={() => select(tab.id)}
            className={cls(
              'w-full sm:w-auto whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium border transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cam-blue',
              selected
                ? 'bg-cam-blue text-white border-cam-blue shadow-sm'
                : 'bg-white text-slate-700 border-slate-300 hover:bg-slate-50'
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}

